<section
  class="particle-veil"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-speed-input]="speed"
  [style.--scene-intensity-input]="intensity"
>
  <div class="particle-grid"></div>
  <div class="veil-haze"></div>

  <span
    *ngFor="let particle of particles"
    class="particle"
    [style.left]="particle.left"
    [style.top]="particle.top"
    [style.width]="particle.size"
    [style.height]="particle.size"
    [style.opacity]="particle.opacity"
    [style.animation-delay]="particle.delay"
    [style.animation-duration]="particle.duration"
    [style.--particle-drift-x]="particle.driftX"
    [style.--particle-drift-y]="particle.driftY"
  ></span>
</section>
